<template>
  <wb-icon class="emh-side-filters-category-head__icon" :name.attr="category.icon"></wb-icon>
  <span class="emh-side-filters-category-head__label">
    {{ category.name }}
    <emh-selected-filters-counter
      class="emh-side-filters-category-head__counter"
      :filters="category.filters"
      hide-zero-counter
    />
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'EmhSideFiltersCategoryHead',
});
</script>

<script setup lang="ts">
import { PropType } from 'vue';
import { IProductFilterGroup } from '@dh-io-emh/shared/src/models/product-filter/product-filter-base.model';
import EmhSelectedFiltersCounter from '../../selectedFiltersCounter/SelectedFiltersCounter.vue';

defineProps({
  category: {
    type: Object as PropType<IProductFilterGroup>,
    required: true,
  },
});
</script>
<style lang="scss">
.emh-side-filters-category-head {
  &__icon {
    flex-shrink: 0;
    margin: 0 var(--wb-spacing-xxs);
    --size: 28px;

    &[name='bds/car/24'] {
      --size: 32px;
    }
    &[name='bds/engine/24'] {
      --size: 26px;
    }
  }

  &__label {
    width: 100%;
  }

  &__counter {
    @include wb-spacing('margin-left', 'xxs');
  }
}
</style>
